import { connect } from "react-redux";
import { withRouter } from "react-router";
import { toggleRightDrawer } from "header/ducks";
import { mapStateToProps } from "brand_studio/containers/brand/preview_gallery_controls";
import HeaderButtons from "brand_studio/components/brand/header_buttons";

export default withRouter(
  connect(mapStateToProps, { toggleRightDrawer })(HeaderButtons)
);
